import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';
import { ModalDismissReasons, NgbAlert, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaskEntryComponent } from 'src/app/Tasks/task-entry/task-entry.component';
import { APIService } from 'src/app/api.service';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-stage-tasks-list',
  templateUrl: './stage-tasks-list.component.html',
  styleUrls: ['./stage-tasks-list.component.scss']
})

export class StageTasksListComponent implements OnInit {
  taskDetails: any = [];
  projectName: any;
  projectId: any;
  mdlRef: any;
  modalHeader: any;
  proj: any;
  jobDetails: any;
  modalReference: any;
  closeResult: any;
  jarvisData: any = [];
  agencyData: any = [];
  stageInfo: any = {};
  domainLink: any = "";
  isGGL: any = false;
  fileToUpload: any;
  fileData: any;
  fileName: any;
  resp: any;
  taskDoneImageVal: any;
  JrUserID: any;
  taskdoneBy: number = 0;
  sendEmailTo: string = '';
  oldStatus: number = 0;
  userList: any = [];
  showImage: any = false;
@ViewChild('mdlCNEntry', { static: false }) mdlCNEntry!: ElementRef;
  constructor(private modalService: NgbModal, public commonService: CommonService, private dataSer: DataService, private apiService : APIService, private http: HttpClient, private SpinnerLoader: NgxSpinnerService) { 
    console.log("Constructor Called");
    this.dataSer.WIPDetails.subscribe((value: any) => {
      this.taskDetails = value.Table4 ? value.Table4 : [];
      if (this.proj && this.proj?.SID) {
        this.taskDetails = this.taskDetails.filter((x:any)=>x.ProjectStageID == this.proj.SID);
        this.stageInfo.isDeletable =  !this.proj.EDT && this.taskDetails.length == 0 ? true : false 
      }
     
      this.projectName = value.Table1[0].JobNo;
      this.projectId = value.Table1[0].JobID;
    });
    if(this.apiService.fn_isLiveURL() == true){
      this.domainLink = "https://biziverse.com/ERPAPI/";
    }
    else{ 
      this.domainLink = "http://localhost:50456/";
    }
  }

  ngOnInit(): void {
    let users = this.apiService.getCookie('J');
    if(users){
      this.userList = JSON.parse(users);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
      this.JrUserID = this.jarvisData[0].UserID;
      if(this.jarvisData.length > 0 && (this.jarvisData[0].AgencyIDs == "1" || this.jarvisData[0].AgencyIDs == "276689" || this.jarvisData[0].AgencyIDs == "276064" || this.jarvisData[0].AgencyIDs == "230836" || this.jarvisData[0].AgencyIDs == "104210" || this.jarvisData[0].AgencyIDs == "295117")) {
        this.isGGL = true;
      }
    };

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    // console.log(this.taskDetails);
    this.taskDetails = this.taskDetails.filter((x:any)=>x.ProjectStageID == this.proj.SID);

    this.stageInfo = {
      stageName: this.proj.SNm,
      dueDT: this.proj.TDT,
      doneDT: this.proj.EDT,
      instructionNotes: this.proj.IN,
      conclusionNotes: this.proj.CN,
      startDT: this.proj.SDT,
      isDeletable: !this.proj.EDT && this.taskDetails.length == 0 ? true : false 
    }
    // console.log(this.proj);

  }

  
  openTaskEntryModal(){
    this.modalReference = this.modalService.open(TaskEntryComponent, {windowClass: 'TaskEntryComponent', backdrop: 'static', size: 'md', keyboard: false});
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    let selProjInfo = {
      projectID: this.projectId,
      projectName: this.projectName,
      projectStageID: this.proj.SID,
      projectStageName: this.stageInfo.stageName,
      fromSatgeTaskList: true
    }
    this.modalReference.componentInstance.selProjInfo = selProjInfo;

    this.modalReference.componentInstance.modalHeader = "Create Task";
    this.modalReference.result.then((result: any) => {
      if (result == 'Done') {
        let tskEntryObj = {projTaskAdded: true, projectStageID: this.proj.SID}
        this.dataSer.updateTaskEntryData(tskEntryObj);
      }
    });

  }
  closeModel(action : string) {
    this.mdlRef.close(action); 
  }

  // markStageDone() - Mark job stage as done.
  markStageDone () {

    // this.openCNEntryModal(this.mdlCNEntry);
    // return;

    let openTasks = this.taskDetails.filter((a: any) => a.StatusID != 3);
    if (openTasks.length > 0) {
      this.apiService.successAlert('This stage cannot be marked as done as there are open tasks linked with it.');
      // this.apiService.errorAlert("This stage cannot be marked as done as there are open tasks linked with it.");
      return;
    }

    let myLastSyncDT = localStorage.getItem("MyLastSyncDT");
  
    var tempData = [{
      'JobID': this.projectId,
      'NewStageID': this.proj.SID,
      'NewStage': this.stageInfo.stageName,
      'targetDT': '',
      'Notes': this.stageInfo.conclusionNotes ? this.stageInfo.conclusionNotes : '',
      'Generation': JSON.stringify(this.jobDetails.generation),
      'Consumption': JSON.stringify(this.jobDetails.consumption),
      'Rejection': JSON.stringify(this.jobDetails.rejection),
      'changeType': 'PRJEND'
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: myLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'MoveJob',
      moduleID: 7,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successDoneStage.bind(this), this.failureDoneStage.bind(this));
  }
  successDoneStage(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        // this.mdlRef.close();
        if (reponseData.Table[0].ErrCode != -1) {
          alert(reponseData.Table[0].ErrMsg);
        }
        else {
          let data = reponseData.Table[0];
          let stages = data.Stages;
          let doneObj: any = {
            action: 'Done',
            stages: stages
          }
          let sendObj = {
            jobNo: this.projectId,
            action: 1
          }
          this.dataSer.updateStageEntered(sendObj);
          this.mdlRef.close(doneObj);
          this.closeCNEntryModal()
        }
      }
    }
  }

  failureDoneStage() {

  }
  //deleteStage() - Delete job stage if not done and if not any tasks
  deleteStage () {
    if (this.proj.EDT) {
      this.apiService.successAlert('This stage was previously marked as done.');
      return;
    }
    if (this.taskDetails.length > 0) {
      this.apiService.successAlert('This stage cannot be deleted as there are tasks linked with it.');
      return;
    }
    let myLastSyncDT = localStorage.getItem("MyLastSyncDT");
    var tempData = [{
      'JobID': this.projectId,
      'NewStageID': this.proj.SID,
      'NewStage': this.stageInfo.stageName,
      'targetDT': '',
      'Notes': this.stageInfo.conclusionNotes ? this.stageInfo.conclusionNotes : '',
      'Generation': JSON.stringify(this.jobDetails.generation),
      'Consumption': JSON.stringify(this.jobDetails.consumption),
      'Rejection': JSON.stringify(this.jobDetails.rejection),
      'changeType': 'PRJDLT' 
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: myLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'MoveJob',
      moduleID: 7,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successDeleteStage.bind(this), this.failureDeleteStage.bind(this));
  }
  successDeleteStage (res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode != -1) {
          alert(reponseData.Table[0].ErrMsg);
        }
        else {
          let data = reponseData.Table[0];
          let stages = data.Stages;
          let doneObj: any = {
            action: 'Done',
            stages: stages
          }
          this.mdlRef.close(doneObj);
        }
      }
    }
  }
  failureDeleteStage () {
  }
  openCNEntryModal(content: any) {
    let openTasks = this.taskDetails.filter((a: any) => a.StatusID != 3);
    if (openTasks.length > 0) {
      this.apiService.successAlert('This stage cannot be marked as done as there are open tasks linked with it.');
      // this.apiService.errorAlert("This stage cannot be marked as done as there are open tasks linked with it.");
      return;
    }

    this.modalReference = this.modalService.open(content, {windowClass: "openStageModal", ariaLabelledBy: 'modal-basic-title' });
    // this.modalReference.componentInstance.prTypeID = this.prTypeID;
  }

  closeCNEntryModal() {
    // this.stageEntry.stageID = 0;
    // this.stageEntry.stageName = '';
    // this.stageEntry.stageOrder = 0;
    this.modalReference.close();
  }
  objTaskData : any;
  openTaskDoneModal(obj: any,content: any) {
    this.objTaskData = obj;
    this.modalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  addAttechmentFile() {
    $('#addAttechment').click();
  }
  //File Upload Region
 handleFileInput(files: FileList) {
      this.fileToUpload = files.item(0);
      let file: File = files[0];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
          this.fileData = reader.result;
      };
      if (this.fileToUpload) {
          this.fileName = this.fileToUpload.name;
          let imageArray = this.fileName.split(".");
          let imageLength = imageArray.length;
          let checkImg = imageArray[imageLength - 1]; 
          if(checkImg == "jpeg" || checkImg == "png" || checkImg == "jpg"){
            this.showImage = true;
          }
      }
  }
  removeAttechUploadedFile() {
    this.fileName = "";
    $('#addAttechment').val('');
  }
  async uploadSEFileNew(callback: any) {
    let sPath = 'TaskDone/';
    var img = "";
    if (this.fileToUpload) {
        img = this.fileToUpload.name;
        this.fileName = img;
    }
    if (img != "") {
        var ServerPath = sPath;
        let url: string = "";
        if(this.apiService.fn_isLiveURL() == true){
            url = "https://biziverse.com/ERPAPI/webservice.asmx/UploadSFile";
        }
        else{ 
            url = "http://localhost:50456/WebService.asmx/UploadSFile";
        }
        this.resp = await this.http.post(url, {
            data: this.fileData,
            path: typeof (img) != 'undefined' ? img : '',
            serverpath: sPath,
        }).toPromise();
        if (this.resp.d.error) {
            alert("Please upload an image, .pdf or .zip file!");
            $('#addAttechment').val('');
            callback(false);
        }
        else {
            this.taskDoneImageVal = this.resp.d.message;
            callback(true);
        }
      }
    }
  saveTaskDoneImage () {
    if(this.fileName){
      this.uploadSEFileNew((obj: boolean) => {
          if(obj == true){
              this.fileName = this.taskDoneImageVal;
              this.changeStatus(this.objTaskData);
          };                        
      });
    }
    else{
      this.changeStatus(this.objTaskData);
    }
  }
  changeStatus(obj: any){
    this.objTaskData = obj;
    this.objTaskData.toUserName = this.jarvisData[0].UserName
    this.objTaskData.fromUserName = this.jarvisData[0].UserName;
    this.objTaskData.StatusID = 3;
    this.oldStatus = this.objTaskData.StatusID;
    let emailUserID = this.objTaskData.CreatedUserID;
    let users = this.userList.filter((o: any) => o.UserID == this.objTaskData.ToUserID);
    if (users.length > 0) {
      this.objTaskData.oldUserID = users[0].UserID;
      this.objTaskData.oldToUserName = users[0].Name;
      this.objTaskData.oldToUserEmail = users[0].Email;        
      this.objTaskData.toUserName = users[0].Name;
      this.objTaskData.toUserEmail = users[0].Email;        
    }
    var toEmailData = $.grep(this.userList, function(o: any){ return o.UserID == emailUserID })
    if(toEmailData.length > 0){
      this.sendEmailTo = toEmailData[0].Email
    }
    let createdUsers = this.userList.filter((o: any) => o.UserID == this.objTaskData.CreatedUserID);
    if(createdUsers.length > 0){
      this.objTaskData.createdUserName= createdUsers[0].Name;
      this.objTaskData.createdUserEmailID = createdUsers[0].Email;
    }
    else{
      this.objTaskData.createdUserName = this.objTaskData.FromUserName;;
    }
      // this.taskUpdate(this.objTaskData.status);
      this.taskUpdate(3);
      // this.taskEditData(2);
  }
  taskUpdate(id: number){
    // its for if my task done by me or other
    let attechLink = '';
    if (this.fileName) {
      attechLink = "Uploads/TaskDone/" + this.taskDoneImageVal;
    }
    else {
          attechLink = "";
    }
  
    if(this.objTaskData.createduserID == this.JrUserID && this.objTaskData.touserID != this.JrUserID){
      this.taskdoneBy = 1
    }
    else if(this.objTaskData.createduserID != this.JrUserID && this.objTaskData.touserID == this.JrUserID){
      this.taskdoneBy = 2
    }
    else{
      this.taskdoneBy = 0
    }
  
    let isConfirm: boolean = true;
      if(this.objTaskData.status == 2){
        isConfirm = confirm("Are you sure you wish to" + (this.objTaskData.status == 2 ? ' cancel this task?' : '')) 
      }
    if (isConfirm) {   
      var tempData = [{
        'TaskID': this.objTaskData.TaskID,
        'ActionType': 'STTS',
        'StatusID': this.objTaskData.StatusID,
        'Tags': '',
        'StatusNote': this.objTaskData.StatusNote ? this.objTaskData.StatusNote  : '',
        'EmailTo': this.sendEmailTo ? this.sendEmailTo : '',
        'EmailFrom': this.objTaskData.toUserName,
        'Task': this.objTaskData.Task,
        'ToUserEmail': this.objTaskData.toUserEmail,
        'DoneByMe': this.taskdoneBy,      
        'FromUserName': this.objTaskData.fromUserName,
        'ToUserName': this.objTaskData.toUserName,
        'LoginUserName': this.jarvisData[0].UserName,
        'TaskCreatoerName': this.objTaskData.createdUserName,
        'TaskReceiverName': this.objTaskData.toUserName,
        'ChangeID': id,
        'TaskCreatorUserID': this.objTaskData.CreatedUserID,
        'TaskReceiverUserID': this.objTaskData.ToUserID,
        'TaskCreatorEmail': this.objTaskData.createdUserEmailID,
        'TaskReceiverEmail': this.objTaskData.toUserEmail,
        'TaskDoneImage': attechLink
    }];
  
    let myParams = [{
              myUserID: this.jarvisData[0].UserID,
              myToken: this.jarvisData[0].WebToken,
              forAgencyID: this.jarvisData[0].AgencyIDs,
              myAgencyIDs: this.jarvisData[0].AgencyIDs,
              myLastSyncDT: null,
              isWeb: true,
              ForERPAgencyID: this.agencyData[0].ERPAgencyID,
              actionType: 'update',
              moduleID: 28,
              data: JSON.stringify(tempData)
          }];
  
    this.apiService.sendChange(myParams, this.successTasksUpdate.bind(this, id), this.failureRespUpdate.bind(this));
    }
    else{
      this.objTaskData.status = this.oldStatus;
    } 
  }

  //successTasksEdit - success edit handler
successTasksUpdate(id: any, res: any) {
  this.SpinnerLoader.hide();
  if (res.error) {
  }
  else {
      let tmpData = JSON.parse(res.updatePackage).Table[0];
      if (tmpData.ErrCode != -1) {
          alert(tmpData.ErrMsg);
          return;
      }
      else {        
        this.fileData = '';
        this.fileName = '';
        // if(this.objTaskData.StatusID == 3) {
        //   this.objTaskData.DoneDT = new Date();
        //  }
        if(id == 1 || id == 0 || id == 10){
          this.apiService.successAlert(id == 1 ? 'Task transferred.' : id == 0 ? 'Status updated.' : id == 10 ? 'Task paused.' : '');
        }
        else if(this.objTaskData.StatusID == 0 || this.objTaskData.StatusID == 1 || this.objTaskData.StatusID == 2 || this.objTaskData.StatusID == 3){
            this.apiService.successAlert(this.objTaskData.StatusID == 0 ? 'Task reopened.' : this.objTaskData.StatusID == 1 ? 'Task paused.' :  this.objTaskData.StatusID == 2 ? 'Task cancelled.' : this.objTaskData.StatusID == 3 ? 'Task done.' : '');
        }
       
        // - Local Cookie Update
        if(this.objTaskData.StatusID == 2 || this.objTaskData.StatusID == 3){
          var localStorageData: any = this.apiService.getCookie('tsk');
          if (localStorageData != null && localStorageData != "" && localStorageData != "null") {
              localStorageData = JSON.parse(localStorageData);
          }
          else {
            localStorageData = [];
          }
          
          let findIndexofLocalStorage = localStorageData.findIndex((x: any) => x.TaskID === this.objTaskData.taskID);
          if (findIndexofLocalStorage > -1) {
            localStorageData[findIndexofLocalStorage].IsRemove = true;
            localStorageData.splice(findIndexofLocalStorage, 1);
            this.apiService.setCookie('tsk',JSON.stringify(localStorageData));
          }
        }        
        let tskEntryObj = {projTaskAdded: true, projectStageID: this.proj.SID}
        this.dataSer.updateTaskEntryData(tskEntryObj);
        // this.closeTaskModal("Done");  
        this.modalReference.close("Cross click");
    } 
  }
}

  //failureRespUpdate - failure handler
  failureRespUpdate(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    }
    else {
        alert(res.message);
    }
  }
}
